import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { PedidoEmailSendValueObject } from '../../../email/pedido-email-send.valueobject';

@Injectable({
    providedIn: 'root'
})
export class PedidoOrcamentoEmailHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedidos-orcamentos`;
    }

    /** Envia o e-mail do orçamento */
    send(valueObject: PedidoEmailSendValueObject): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/${valueObject?.id}/emails`, valueObject, {responseType: 'text'});
    }
}
